import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomeBanner() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <>
          <div id="slider-one" className={`main-slider-area ${loaded ? 'fade-in' : ''}`}>
        <div className="slider-bg">
          <div className="item">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="slider__content">
                    {/* ---------- HEADLINE ---------- */}
                    <h1 className="main-title-one">
                      Native&nbsp;SMS via&nbsp;HighLevel or API<br />
                      <span className="accent-text">Bring your own&nbsp;SIM</span>
                      <span className="accent-text">
                        <br />
                        From&nbsp;$0.001&nbsp;/&nbsp;SMS
                      </span>
                    </h1>

                    {/* ---------- SUB-COPY ---------- */}
                    <p className="aftertitle-p">
                      Plug any Android phone into GHL in under&nbsp;5&nbsp;minutes—no 10DLC or
                      A2P paperwork.
                      <br className="d-none d-md-block" />
                      Save up to&nbsp;95&nbsp;% while keeping full control through our native
                      Conversation Provider <strong>and a fully documented REST&nbsp;API</strong>.
                    </p>

                    {/* ---------- FEATURES ---------- */}
                    <div className="features-container">
                      <div className="features-grid">
                        <div className="feature-card">
                          <div className="feature-icon">💸</div>
                          <div className="feature-content">
                            <h3>Up&nbsp;to 95&nbsp;% Cheaper</h3>
                            <p>Pay true carrier rates</p>
                          </div>
                        </div>

                        <div className="feature-card">
                          <div className="feature-icon">
                            <img
                              src="https://app.matatika.com/assets/logos/extractors/gohighlevel.png"
                              alt="GoHighLevel logo"
                              className="ghl-logo"
                            />
                          </div>
                          <Link className="ghl-link" to="/ghl">
                            <div className="feature-content">
                              <h3>Native&nbsp;GHL Provider</h3>
                              <p>One-click Conversation Provider</p>
                            </div>
                          </Link>
                        </div>

                        <div className="feature-card">
                          <div className="feature-icon">🚫</div>
                          <div className="feature-content">
                            <h3>Zero&nbsp;A2P / 10DLC</h3>
                            <p>Skip all registration headaches</p>
                          </div>
                        </div>

                        <div className="feature-card">
                          <div className="feature-icon">⚡</div>
                          <div className="feature-content">
                            <h3>5-Minute Setup</h3>
                            <p>QR-scan & link multiple sub-accounts</p>
                          </div>
                        </div>

                        {/* ---------- NEW API CARD ---------- */}
                      
                      </div>
                    </div>

                    {/* ---------- CTAs ---------- */}
                    <div className="cta-buttons">
                      <Link className="cta-primary" to="/signup">
                        Start Free Trial&nbsp;➔
                      </Link>
                      <Link className="cta-secondary" to="/how-textlink-works">
                        <span>See How It Works</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M5 12H19M19 12L13 6M19 12L13 18"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ---------- VIDEO ---------- */}
        <div className="video-section">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-6 px-0">
              <h2 className="video-title">Introduction Video</h2>
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/nC_In3YIA9Y"
                  title="Introduction Video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Base Styling */
        .main-slider-area {
          padding: 6rem 0 4rem;
          background: #f8faff;
          transition: opacity 0.5s ease;
          opacity: 0;
        }
        .main-slider-area.fade-in {
          opacity: 1;
        }
        .container-fluid {
          padding: 0 1rem;
        }
        .slider__content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
          text-align: center;
          margin-top:50px
        }
        .main-title-one {
          font-size: 2rem;
          font-weight: 800;
          color: #0f172a;
          margin: 1rem 0 1rem;
          line-height: 1.2;
        }
        .accent-text {
          color: #3b82f6;
          font-weight: 900;
        }
        .aftertitle-p {
          font-size: 1rem;
          color: #475569;
          margin: 0 auto 2rem;
          line-height: 1.6;
          max-width: 800px;
        }

        /* Feature Cards */
        .features-container {
          width: 100%;
          overflow: hidden;
          margin-bottom: 2rem;
        }
        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 1.5rem;
        }
        .feature-card {
          background: #ffffff;
          border-radius: 12px;
          padding: 1.5rem;
          display: flex;
          align-items: center;
          gap: 1rem;
          border: 1px solid #e2e8f0;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .feature-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
        }
        .feature-icon {
          font-size: 1.75rem;
          flex-shrink: 0;
        }
        .ghl-logo {
          width: 40px;
          height: 40px;
          object-fit: contain;
        }
        .feature-content h3 {
          font-size: 1.1rem;
          color: #0f172a;
          margin-bottom: 0.25rem;
          font-weight: 700;
          text-align: left;
        }
        .feature-content p {
          color: #64748b;
          margin: 0;
          font-size: 0.9rem;
          line-height: 1.4;
          text-align: left;
        }

        /* CTA Buttons */
        .cta-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          justify-content: center;
          margin-top: 2rem;
        }
        .cta-primary {
          background: #3b82f6;
          color: #ffffff;
          padding: 1rem 2rem;
          border-radius: 8px;
          font-weight: 600;
          text-decoration: none;
          transition: background 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }
        .cta-primary:hover {
          background: #2563eb;
        }
        .cta-secondary {
          padding: 1rem 2rem;
          border-radius: 8px;
          font-weight: 600;
          text-decoration: none;
          background: #ffffff;
          color: #3b82f6;
          border: 2px solid #e2e8f0;
          transition: background 0.3s ease, color 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }
        .cta-secondary:hover {
          background: #3b82f6;
          color: #ffffff;
        }

        /* Video Section */
        .video-section {
          width: 100%;
          padding: 2rem 1rem 0;
        }
        .video-title {
          font-size: 1.5rem;
          color: #0f172a;
          margin-bottom: 1.5rem;
          text-align: center;
        }
        .video-container {
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .video-container iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: none;
        }

        /* Responsive Adjustments */
        @media (min-width: 640px) {
          .main-slider-area {
            padding: 6rem 0 4rem;
          }
          .main-title-one {
            font-size: 2.5rem;
          }
          .aftertitle-p {
            font-size: 1.1rem;
          }
          .features-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (min-width: 768px) {
          .main-title-one {
            font-size: 3rem;
          }
          .features-grid {
            grid-template-columns: repeat(4, 1fr);
          }
         .video-section {
    max-width: 960px;
    margin: 4rem auto 0;
  }
        }
        @media (max-width: 480px) {
         .slider__content {
          margin-top:50px
        }
          .main-slider-area {
            padding-top: 7rem;
          }
          .feature-card {
            padding: 1rem;
          }
          .ghl-logo {
            width: 35px;
            height: 35px;
          }
          .cta-primary,
          .cta-secondary {
            width: 100%;
            justify-content: center;
            text-align: center;
          }

        }
          /*   NEW   */
@media (min-width: 1200px) {
  /* on large desktops let it stretch a bit more, but still stay balanced */
  .video-section {
    max-width: 1120px;   /* ≈70 % of a 1600-px viewport */
  }
}
      `}</style>
    </>
  );
}
